<!-- Notifications Bell Button -->
<button 
    mat-icon-button 
    [matMenuTriggerFor]="notificationsMenu"
    #menuTrigger="matMenuTrigger"
    (menuOpened)="onMenuOpened()"
    [matBadge]="unreadCount > 99 ? '99+' : unreadCount"
    [matBadgeHidden]="unreadCount === 0"
    matBadgeColor="warn"
    matBadgeSize="small"
    class="notifications-bell"
    matTooltip="Powiadomienia">
    <mat-icon [svgIcon]="'tabler_outline:bell'"></mat-icon>
</button>

<!-- Notifications Menu -->
<mat-menu #notificationsMenu="matMenu" class="notifications-menu" xPosition="before">
    <div class="notifications-container" (click)="$event.stopPropagation()">
        
        <!-- Header -->
        <div class="flex items-center justify-between px-4 py-3 border-b border-gray-200 dark:border-gray-700">
            <h3 class="text-base font-semibold text-gray-800 dark:text-gray-200">
                Powiadomienia
            </h3>
            <div class="flex items-center gap-2">
                <button 
                    *ngIf="unreadCount > 0"
                    mat-button 
                    color="primary" 
                    class="!text-xs !min-w-0 !px-2 !py-1"
                    (click)="markAllAsRead()">
                    Oznacz jako przeczytane
                </button>
            </div>
        </div>

        <!-- Loading -->
        <div *ngIf="isLoading" class="flex items-center justify-center py-8">
            <mat-spinner diameter="32"></mat-spinner>
        </div>

        <!-- Empty State -->
        <div *ngIf="!isLoading && notifications.length === 0" class="py-8 px-4 text-center">
            <div class="w-16 h-16 mx-auto mb-3 rounded-full bg-gray-100 dark:bg-gray-700 flex items-center justify-center">
                <mat-icon [svgIcon]="'tabler_outline:bell-off'" class="!w-8 !h-8 text-gray-400"></mat-icon>
            </div>
            <p class="text-gray-500 dark:text-gray-400 text-sm">
                Brak powiadomień
            </p>
        </div>

        <!-- Notifications List -->
        <div *ngIf="!isLoading && notifications.length > 0" class="notifications-list">
            <div 
                *ngFor="let notification of notifications"
                class="notification-item group"
                [class.unread]="!notification.isRead"
                [class.clickable]="notification.metadata?.documentId || notification.metadata?.actionUrl"
                (click)="onNotificationClick(notification)">
                
                <!-- Icon -->
                <div class="notification-icon" [ngClass]="getIconBgClass(notification)">
                    <mat-icon [svgIcon]="getIcon(notification)" class="!w-5 !h-5" [ngClass]="getColorClass(notification)"></mat-icon>
                </div>

                <!-- Content -->
                <div class="notification-content">
                    <div class="notification-title" [class.font-semibold]="!notification.isRead">
                        {{ notification.title }}
                    </div>
                    <div class="notification-message">
                        {{ notification.message }}
                    </div>
                    <div class="notification-time">
                        <date-formatter [date]="notification.createdAt" [showTime]="true"></date-formatter>
                    </div>
                </div>

                <!-- Actions -->
                <div class="notification-actions">
                    
                    <!-- Unread indicator - zawsze czerwona -->
                    <div 
                        *ngIf="!notification.isRead" 
                        class="w-2 h-2 rounded-full bg-red-500">
                    </div>
                    
                    <!-- Delete button (shows on hover) -->
                    <button 
                        mat-icon-button 
                        class="!w-8 !h-8 opacity-0 group-hover:opacity-100 transition-opacity"
                        (click)="deleteNotification($event, notification)"
                        matTooltip="Usuń">
                        <mat-icon [svgIcon]="'tabler_outline:x'" class="!w-4 !h-4"></mat-icon>
                    </button>
                </div>
            </div>
        </div>

    </div>
</mat-menu>
